// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function Information() {
  return (
    <MKBox component="section" py={8}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={50} md={32}>
            <Grid container justifyContent="flex-start">
              <MKTypography variant="body1" mt={1} mb={0}>
                At Scuba Addicts, we believe diving is more than a sport — it’s a gateway to wonder.
                Nestled along Sri Lanka’s beautiful coastline, we offer unforgettable underwater
                experiences for beginners and seasoned divers alike. From colorful coral reefs and
                fascinating shipwrecks to encounters with turtles, rays, and schools of tropical
                fish, every dive is a new story waiting to be told. With our passionate, certified
                team and top-quality equipment, we ensure every adventure is safe, fun, and truly
                memorable.
              </MKTypography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
